import { render, staticRenderFns } from "./IndexScriptModal.vue?vue&type=template&id=6ade582c&scoped=true"
import script from "./IndexScriptModal.vue?vue&type=script&lang=js"
export * from "./IndexScriptModal.vue?vue&type=script&lang=js"
import style0 from "./IndexScriptModal.vue?vue&type=style&index=0&id=6ade582c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ade582c",
  null
  
)

export default component.exports